import { useEffect, useState, useCallback, useContext } from "react";
import { useSnackbar } from "notistack";
import AddEditCourseDialog from "./AddEditCourseDialog";
import useAuthenticatedRestCall from "../../hooks/useAuthenticatedRestCall";
import { useUploadCourseCompletionImage } from "../../hooks/useUploadCourseCompletionImage";
import ClientContext from "../../contexts/ClientContext";
import useExistingTitleTranslationsInDialog from "../../hooks/useExistingTitleTranslationsInDialog";

export default function EditLevelDialog(props) {
  const makeAuthenticatedRequest = useAuthenticatedRestCall();
  const { enqueueSnackbar } = useSnackbar();
  const uploadCourseCompletionImage = useUploadCourseCompletionImage();
  const { clientInfo } = useContext(ClientContext);
  const [imageSrc, setImageSrc] = useState(null);
  const [newImageUploaded, setNewImageUploaded] = useState(false);

  const { existingTitleTranslations } = useExistingTitleTranslationsInDialog(
    props.open,
    `${process.env.REACT_APP_COURSE_SERVICE_URL}/levels/${props.course.levelId}/courses/${props.course.id}`
  );

  const fetchCourseCompletionImage = useCallback(() => {
    makeAuthenticatedRequest(
      `${process.env.REACT_APP_IMAGE_SERVICE_URL}/clients/${clientInfo.clientId}/levels/${props.course.levelId}/courses/${props.course.id}/course-completion-image`,
      false
    )
      .then((result) => {
        setImageSrc(result.data.location);
      })
      .catch(() => {
        setImageSrc("");
      });
  }, [
    makeAuthenticatedRequest,
    clientInfo.clientId,
    props.course.id,
    props.course.levelId,
  ]);

  useEffect(() => {
    if (props.open && !newImageUploaded) {
      fetchCourseCompletionImage();
    }
  }, [props.open, fetchCourseCompletionImage, newImageUploaded]);

  const handleConfirm = (name, passingGrade, imageFile, titleTranslations) => {
    makeAuthenticatedRequest(
      `${process.env.REACT_APP_COURSE_SERVICE_URL}/levels/${props.levelId}/courses/${props.course.id}`,
      false,
      {
        data: {
          name,
          passingGrade,
          titleTranslations,
        },
        method: "PUT",
      }
    ).then((response) => {
      enqueueSnackbar(`${name} updated!`, {
        variant: "success",
      });

      if (imageFile) {
        uploadCourseCompletionImage(
          props.levelId,
          response.data.id,
          imageFile
        ).then(() => {
          setNewImageUploaded(true);
          setImageSrc(`${imageSrc}#${Math.random()}`);
        });
      }

      props.onCourseModified(response.data);
    });

    props.onClose();
  };

  return (
    <AddEditCourseDialog
      title="Edit course"
      open={props.open}
      onClose={props.onClose}
      onConfirm={handleConfirm}
      confirmText="Save course"
      initialName={props.course.name}
      initialPassingGrade={props.course.passingGrade}
      imageLoading={imageSrc === null}
      initialImageSrc={imageSrc}
      existingTitleTranslations={existingTitleTranslations}
      loading={existingTitleTranslations === null}
    />
  );
}
